export const applyStateupdate = (state: any, action: any) => {
    state[action.type] = action.payload;
    return state;
};
